<template>
  <div class="d-flex product-card">
    <v-skeleton-loader type="image" class="product-card__image flex-grow-0" />
    <div class="ml-2 mr-1 product-card__text">
      <v-skeleton-loader type="heading" />
      <v-skeleton-loader type="text" />
      <v-skeleton-loader type="text" />
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'

export default Vue.extend({
  name: 'ProductCardSkeleton',
})
</script>
